"use client";
import { Suspense, useEffect, useState } from "react";

import { NavigationBar } from "../../components/layout/Navigation/Navigation";
import { Header } from "../../components/layout/Header/Header";
import { LayoutWrapper } from "../../components/layout/LayoutWrapper/LayoutWrapper";
import { Analytics } from "@/utilities/analytics";
import { MainCategoryEnum, ScreenEnum } from "@/types/Analytics";
import { useSessionKeepAliveAndIdle } from "@/services/_utils";

export interface DashboardProps {
  children: React.ReactNode;
}

export default function DashboardLayout(props: Readonly<DashboardProps>) {
  const { children } = props;
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  // Keep session alive while user is active
  useSessionKeepAliveAndIdle();

  const menuOpened = () => {
    setIsMenuOpened(true);
    Analytics.logEvent("cta_menu", {
      action: "menu",
      main_category: MainCategoryEnum.MY_ACCOUNT,
      target_screen: ScreenEnum.MY_ACCOUNT_HOME,
    });
  };

  useEffect(() => {
    if (sessionStorage.getItem("isPassedStatus") !== "true") {
      document.getElementById("report-nav")?.classList.add("report-nav-hidden");
    } else {
      document
        .getElementById("report-nav")
        ?.classList.remove("report-nav-hidden");
    }
  }, []);

  const menuClosed = () => {
    setIsMenuOpened(false);
  };

  return (
    <>
      <Header isMenuOpened={isMenuOpened} />
      <NavigationBar menuOpened={menuOpened} menuClosed={menuClosed} />
      <main>
        <LayoutWrapper>
          <Suspense>{children}</Suspense>
        </LayoutWrapper>
      </main>
    </>
  );
}
